import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { cn } from "@/lib/utils"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, icon, ...props }) {
        const isNotification = props.variant === "notification"
        return (
          <Toast key={id} {...props}>
            <div className={cn("flex min-w-0 items-center", icon ? "gap-3" : "gap-0")}>
              {icon && <div className="shrink-0">{icon}</div>}
              <div className="grid min-w-0 gap-1">
                {title && (
                  <ToastTitle className={cn(isNotification && "text-[13px] font-semibold text-[var(--tg-text-primary)]")}>
                    {title}
                  </ToastTitle>
                )}
              {description && (
                  <ToastDescription
                    className={cn(
                      isNotification &&
                        "text-[12px] text-[var(--tg-text-secondary)] opacity-100"
                    )}
                  >
                    {description}
                  </ToastDescription>
              )}
              </div>
            </div>
            {action}
            <ToastClose
              className={cn(
                isNotification &&
                  "text-[var(--tg-text-muted)] hover:text-[var(--tg-text-primary)] focus:ring-[var(--tg-accent-soft)]"
              )}
            />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
